<div>
  <div class="bar-title">Attendance</div>
</div>
<div>
  <attendance-tabs (loadPageEvent)="this.loadPage($event)" [currentTab]="this.tabName"></attendance-tabs>
</div>
<div class="content">
  <ng-template attendanceHost></ng-template>
</div>